module.exports = __webpack_public_path__ + "static/media/Apps.d5bab7a3.svg";